var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_5985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86972 0.199463C3.46088 0.199463 0.698975 2.96137 0.698975 6.37021C0.698975 9.77905 3.46088 12.541 6.86972 12.541C10.2786 12.541 13.0405 9.77905 13.0405 6.37021C13.0405 2.96137 10.2786 0.199463 6.86972 0.199463ZM8.29049 8.91067L6.09589 7.31573C6.01876 7.2585 5.97397 7.16892 5.97397 7.07437V2.88672C5.97397 2.7225 6.10833 2.58814 6.27255 2.58814H7.46689C7.63111 2.58814 7.76547 2.7225 7.76547 2.88672V6.31298L9.34548 7.46253C9.47985 7.55957 9.50722 7.74619 9.41018 7.88055L8.7085 8.84597C8.61146 8.97785 8.42485 9.00771 8.29049 8.91067Z",
    fill: "#A7ABB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_5985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7396,
    height: 12.7396,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2601e54169dca73aefca2055f21dd7d4.svg";
export { ForwardRef as ReactComponent };